import * as React from "react";
import { FormGroup } from "../RightAsideHelpers";
import Select from "@/components/Select";
import { WorkflowNode } from "../../types";
import useAIConfigs from "@/hooks/useAIConfigs";
import useNetSuiteConfigs from "@/hooks/useNetSuiteConfigs";

interface Props {
  node: WorkflowNode;
  onUpdate: (node: Partial<WorkflowNode>) => void;
}

export default function NetsuiteAIEditor({ node, onUpdate }: Props) {
  const { aiConfigurations } = useAIConfigs();
  const { items: netSuiteConfigs } = useNetSuiteConfigs(0);

  const aiOptions = aiConfigurations.map((ai) => ({
    value: ai.id,
    label: ai.name
  }));

  const nsOptions = netSuiteConfigs.map((ns) => ({
    value: ns.id,
    label: ns.displayName || ns.company || `Config #${ns.id}`
  }));

  return (
    <>
      <FormGroup label="AI Config">
        <Select
          options={aiOptions}
          value={node.aiConfigId}
          onChange={(value) => {
            onUpdate({ aiConfigId: Number(value) });
          }}
        />
      </FormGroup>
      <FormGroup label="NetSuite Config">
        <Select
          options={nsOptions}
          value={node.netSuiteConfigId}
          onChange={(value) => {
            onUpdate({ netSuiteConfigId: Number(value) });
          }}
        />
      </FormGroup>
    </>
  );
}
